export enum ESettingsTabOptions {
  GlobalPreference = 0,
  Administrator = 1,
  License = 2,
  OrphanImages = 3,
  Support = 4,
}

export const SideTabs = [
  { key: ESettingsTabOptions.GlobalPreference, value: 'globalpreferences' },
  { key: ESettingsTabOptions.Administrator, value: 'administrator' },
  { key: ESettingsTabOptions.License, value: 'license' },
  { key: ESettingsTabOptions.OrphanImages, value: 'orphanImages' },
  { key: ESettingsTabOptions.Support, value: 'support' },
];
